import classNames from 'classnames';
import React from 'react';

import css from './IconPersonalCare.module.css';

const IconPersonalCare = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
    >
      <path
        d="M47 28H17a5.006 5.006 0 0 0-5 5v10a5.006 5.006 0 0 0 5 5h30a5.006 5.006 0 0 0 5-5V33a5.006 5.006 0 0 0-5-5Zm3 15a3.003 3.003 0 0 1-3 3H17a3.003 3.003 0 0 1-3-3V33a3.003 3.003 0 0 1 3-3h30a3.003 3.003 0 0 1 3 3ZM29 10a4 4 0 1 0-4-4 4.004 4.004 0 0 0 4 4Zm0-6a2 2 0 1 1-2 2 2.002 2.002 0 0 1 2-2Zm22 16H38.65a5.985 5.985 0 0 0-9.834-6.282 5.642 5.642 0 0 0-3.392-.685A8.013 8.013 0 0 0 18 8a7.887 7.887 0 0 0-2.977.577A5.978 5.978 0 0 0 5 13a5.128 5.128 0 0 0 .06.78 5.985 5.985 0 0 0-.464 10.155A11.013 11.013 0 0 0 2 31v20a11.012 11.012 0 0 0 11 11h38a11.012 11.012 0 0 0 11-11V31a11.012 11.012 0 0 0-11-11ZM6.566 15.279a1 1 0 0 0 .603-1.202 3.972 3.972 0 0 1 6.865-3.65 1.003 1.003 0 0 0 1.222.242A5.918 5.918 0 0 1 18 10a6.005 6.005 0 0 1 5.786 4.437 1.003 1.003 0 0 0 1.217.707 3.796 3.796 0 0 1 3.395.678 1 1 0 0 0 1.406-.2A3.963 3.963 0 0 1 33 14a4 4 0 0 1 0 8 3.955 3.955 0 0 1-2.398-.822 1 1 0 0 0-1.406.2 3.976 3.976 0 0 1-6.493-.119 1 1 0 0 0-1.379-.265 5.987 5.987 0 0 1-7.85-1.065 1 1 0 0 0-1.703.338 3.988 3.988 0 1 1-5.205-4.988ZM51 60H13a9.004 9.004 0 0 1-8.983-8.673A10.987 10.987 0 0 0 13 56h38a10.987 10.987 0 0 0 8.983-4.673A9.004 9.004 0 0 1 51 60Zm0-6H13a9.01 9.01 0 0 1-9-9V31a8.876 8.876 0 0 1 2.503-6.197 5.928 5.928 0 0 0 6.517-2.55 7.984 7.984 0 0 0 8.625.869A5.995 5.995 0 0 0 26 25a5.919 5.919 0 0 0 4.184-1.718A5.874 5.874 0 0 0 33 24a5.98 5.98 0 0 0 4.46-2H51a9.01 9.01 0 0 1 9 9v14a9.01 9.01 0 0 1-9 9Z"
        data-name="06-Soap"
        fill="#011602"
      />
    </svg>
  );
};

export default IconPersonalCare;
